import Flipper from "@/modules/flipper";
import User from "@/modules/user";
import { computed } from "vue";

export function useMagicBackgroundFlag() {
  const isMagicBackgroundsEnabled = computed(() => Flipper.isEnabled("magic_backgrounds") && !User.isFromChina());
  return { isMagicBackgroundsEnabled };
}
